import { styled } from '@mui/system';
import { Dialog } from '@mui/material';
export const StyledDialog = styled(Dialog)(({ theme, sx }) => ({
    '& .MuiDialog-paper': {
        backgroundColor: theme.palette.background.default,
    },
    // '& .MuiDialogTitle-root': {
    //     display: 'flex',
    //     flexDirection: 'column',
    //     alignItems: 'center',
    //     textAlign: 'center',
    //     padding: theme.spacing(4, 4, 0)
    // },
    '& .MuiDialogContent-root': {
        // minWidth: '300px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        padding: theme.spacing(4, 4),
        borderBottom: `2px solid ${theme.palette.divider}`
    },
    '& .MuiDialogActions-root': {
        height: '100%',

    },
    ...sx
}));
